export default (params) => {
  const { editor, type } = params;

  const {
    value: {
      selection: { isCollapsed },
    },
  } = editor;
  /**
   * * *  WORK AROUND * * *
   * when the selection state is collapsed
   * So, had to add few operations to detect
   * ADD_MARK in onChange event
   */
  if (isCollapsed) {
    editor.insertText(' ');
    editor.toggleMark(type);
    editor.deleteBackward(1);
  } else editor.toggleMark(type);
};
